// Player a facciata (DESIGN.md, Video): al clic la copertina lascia il posto
// al player di YouTube. Prima del clic nessuna richiesta a YouTube.
let ready = false;

export function setupVideoFacade() {
  if (ready) return;
  ready = true;
  document.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest('.video-facade');
    if (!button) return;
    const frame = document.createElement('iframe');
    frame.src = button.dataset.src;
    frame.title = button.dataset.title || 'YouTube';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    // Senza referrer YouTube rifiuta il player (errore 153)
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.className = 'video-frame';
    button.replaceWith(frame);
    frame.focus();
  });
}
